import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`Please note that the `}<a parentName="p" {...{
          "href": "/api/../api/projects/order-edits"
        }}>{`OrderEdit`}</a>{` feature in its initial release does not support the tracking or reserving of inventory. An `}<a parentName="p" {...{
          "href": "/api/../api/projects/order-edits"
        }}>{`OrderEdit`}</a>{` can therefore only be created if the `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#inventorymode"
        }}>{`InventoryMode`}</a>{` of the order is `}<inlineCode parentName="p">{`"None"`}</inlineCode>{`.`}</p>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      